import { fetchNoticeListInfo, fetchNoticeHit, fetchNoticeDetailInfo, fetchNoticeWrite, deleteNotice } from '@/api/api.notice'

const noticeStoreModule = {
  state    : {
    noticeInfo: [],
  },
  getters  : {},
  mutations: {
    SET_NOTICE_LIST (state, noticeInfo) {
      state.noticeInfo = noticeInfo
    },
    SET_NOTICE_ERROR (state, error) {
      kendo.alert(error);
    },
  },
  actions  : {
    FETCH_NOTICE_LIST (context, params) {
      return new Promise(resolve => {
        fetchNoticeListInfo(params).then(response => {
          if (response.data.resultStatus.messageCode === '2000') {
            context.commit('SET_NOTICE_LIST', response.data.resultData)
            resolve(response.data)
          } else {
            context.commit('SET_NOTICE_ERROR', response.data.resultStatus.messageText)
          }
        }).catch(error => {
          context.commit('SET_NOTICE_ERROR', error)
        })
      })

    },
    FETCH_NOTICE_DETAIL (context, params) {
      return new Promise(resolve => {
        fetchNoticeDetailInfo(params).then(response => {
          if (response.data.resultStatus.messageCode === '2000') {
            resolve(response.data)
          } else {
            context.commit('FETCH_NOTICE_DETAIL_ERROR', response.data.resultStatus.messageText)
          }
        }).catch(error => {
          console.log('==================== error ====================')
          console.log(error)
          context.commit('SET_NOTICE_ERROR', error)
        })
      })
    },
    FETCH_NOTICE_WRITE (context, params) {
      return new Promise(resolve => {
        fetchNoticeWrite(params).then(response => {
          if (response.data.resultStatus.messageCode === '2000') {
            resolve(response.data)
          } else {
            context.commit('FETCH_NOTICE_WRITE_ERROR', response.data.resultStatus.messageText)
          }
        }).catch(error => {
          console.log('==================== error ====================')
          console.log(error)
          context.commit('SET_NOTICE_ERROR', error)
        })
      })
    },
    DELETE_NOTICE_DETAIL (context, params) {
      return new Promise(resolve => {
        deleteNotice(params).then(response => {
          if (response.data.resultStatus.messageCode === '2000') {
            resolve(response.data)
          } else {
            context.commit('DELETE_NOTICE_DETAIL_ERROR', response.data.resultStatus.messageText)
          }
        }).catch(error => {
          console.log('==================== error ====================')
          console.log(error)
          context.commit('SET_NOTICE_ERROR', error)
        })
      })
    },

    /*    FETCH_INSERT_USER_INFO (context, credentials) {
     return new Promise(resolve => {
     fetchInsertUserInfo(credentials).then(response => {
     if (!response.data.resultStatus.messageCode === '2000') {
     context.commit('SET_ERROR', response.data.resultStatus.messageText)
     } else {
     resolve(response.data)
     }
     }).catch(error => {
     console.log('==================== FETCH_INSERT_USER_INFO error ====================')
     console.log(error)
     context.commit('SET_ERROR', error)
     })
     })
     },*/
  },
}

export default noticeStoreModule
